import "./modaal-ajax--split";



// WEBPACK FOOTER //
// ./client/src/core/components/modaal-ajax/index.js